import EventBus from '../../../../../../modules/EventBus';
import { MINDEN_BIZTOSITO } from '../../../../../../modules/Biztosito';
import {
    FERFI, MINDEN_MODOZAT, NO,
} from '../../../../../../modules/Const';
import {MOTOR, SZGK, TEHER} from '../../../../../../modules/Gepjarmu';
import TariffAnnouncementUtils from '../../../../../../utils/TariffAnnouncementUtils';

export default {
    methods: {
        homeOfficeVisible() {
            if (this.$store.getters.uzembentarto.sex === 3) return false;

            const szuletesiEv = parseInt(this.$store.getters.uzembentarto.birthdate.toString().substr(0, 4), 10);
            const kockKezdYear = parseInt(this.$store.getters.tarifaData.ajanl_kock_kezd.toString().substr(0, 4), 10);
            const youngerThan65 = (kockKezdYear - szuletesiEv) < 65;
            return this.isSZGK()
                && this.isTermeszetesSzemely()
                && youngerThan65
                && TariffAnnouncementUtils.isKockakezdetEqualOrGreater(2022, 'kgfb', this.$store);
        },
        getKedvezmenyCount() {
            return [...this.$refs.kedvezmeny.childNodes].filter((element) => element.nodeName === 'DIV').length;
        },
        getSelectedKedvezmenyCount() {
            return [
                ...this.$refs.kedvezmeny.childNodes,
            ]
                .filter(
                    (element) => element.nodeName === 'DIV',
                )
                .filter(
                    (element) => element
                        .children[0]
                        .children[0]
                        .children[2]
                        .children[0]
                        .children[0]
                        .children[0]
                        .children[0]
                        .children[0]
                        .checked === true,
                ).length;
        },
        shouldRecalc() {
            EventBus.$emit('should-recalc', { biztosito: this.biztositoid, modozat: this.modozat });
        },
        getValue(propName) {
            return this.$getNestedPropVal(this.$store.getters, propName.split('.'));
        },
        isTermeszetesSzemely() {
            return [FERFI, NO].includes(this.getValue('uzembentarto.sex'));
        },
        isSZGK() {
            return this.getValue('gepjarmu.fajta') === SZGK;
        },
        isMKP() {
            return this.getValue('gepjarmu.fajta') === MOTOR;
        },
        hasDrivingLicence() {
            return this.getValue('uzembentarto.has_licence');
        },
        isTeherKisebb3500kg() {
            return this.getValue('gepjarmu.fajta') === TEHER && this.getValue('gepjarmu.ossztomeg') <= 3500;
        },
    },
    computed: {
        egyuttkotve() {
            return this.$store.getters.egyuttkotottBiztosito === this.biztositoid && this.$store.getters.azonosKockkezd;
        },
    },
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        biztositoid: {
            type: Number,
            required: true,
            validator: (value) => MINDEN_BIZTOSITO.includes(value),
        },
        modozat: {
            type: Number,
            required: true,
            validator: (value) => MINDEN_MODOZAT.includes(value),
        },
    },
};
